(function () {
  angular.module("akitabox.mobile.directives", [
    "akitabox.mobile.directives.assetInput",
    "akitabox.mobile.directives.backNav",
    "akitabox.mobile.directives.buildingInput",
    "akitabox.mobile.directives.buildingListItem",
    "akitabox.mobile.directives.floorInput",
    "akitabox.mobile.directives.inputCard",
    "akitabox.mobile.directives.inputProgress",
    "akitabox.mobile.directives.listItem",
    "akitabox.mobile.directives.menuList",
    "akitabox.mobile.directives.noteInput",
    "akitabox.mobile.directives.pinValueList",
    "akitabox.mobile.directives.qrScanner",
    "akitabox.mobile.directives.roomInput",
    "akitabox.mobile.directives.searchBar",
    "akitabox.mobile.directives.headerHider",
    "akitabox.mobile.directives.sticky",
    "akitabox.mobile.directives.textCard",
    "akitabox.mobile.directives.treeInput",
  ]);
})();
